"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { ArrowUpRight } from "lucide-react";
function CuratedCollectionsConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className={`aspect-[1/1] w-full animate-pulse bg-muted ${i === 1 ? "md:mt-12" : ""}`} />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-muted-foreground mb-4">
          Failed to load wellness categories.
        </p>
        <button onClick={refetch} className="text-sm font-default font-medium underline underline-offset-4 hover:text-primary transition-colors">
          Try again
        </button>
      </div>;
  }
  if (terms.length === 0) {
    return null;
  }
  const displayTerms = [...terms.slice(0, 3)];
  const wellnessIndex = displayTerms.findIndex(t => t.name === "Wellness Services");
  if (wellnessIndex !== -1 && wellnessIndex !== 1) {
    const [wellnessTerm] = displayTerms.splice(wellnessIndex, 1);
    displayTerms.splice(1, 0, wellnessTerm);
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-8 lg:gap-12">
      {displayTerms.map((term, i) => <div key={term.id} data-index={i} className={`group relative overflow-hidden ${i === 1 ? "md:mt-12" : ""}`}>
          <Link to={term.link || "/ShopPage"} className="block h-full w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
            <div className="aspect-[1/1] w-full overflow-hidden bg-primary">
              {term.name === "IV Therapy" ? <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/iv.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/iv.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/iv.png-wvc-sizes" alt="Modern IV Therapy Treatment" className="h-full w-full object-cover opacity-60 transition-all duration-1000 ease-in-out group-hover:scale-110 group-hover:opacity-80" loading="lazy" /> : term.name === "Vitamin Injections" ? <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/inj.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/inj.png-wvc-srcset" data-wvc-sizes="/img/artifact_img_pbgsdndp.png-sizes" alt="Vitamin Injections" className="h-full w-full object-cover opacity-60 transition-all duration-1000 ease-in-out group-hover:scale-110 group-hover:opacity-80" loading="lazy" /> : term.image_url ? <img src={term.image_url} data-wvc-srcset={`${term.image_url}-wvc-srcset`} data-wvc-sizes={`${term.image_url}-wvc-sizes`} alt={term.name} className="h-full w-full object-cover opacity-60 transition-all duration-1000 ease-in-out group-hover:scale-110 group-hover:opacity-80" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-primary/10">
                  <span className="text-primary font-default text-sm uppercase tracking-widest">
                    {term.name}
                  </span>
                </div>}
            </div>

            <div className="absolute bottom-6 left-6 flex items-center gap-3 bg-background/10 px-6 py-4 backdrop-blur-md transition-all duration-500 ease-out group-hover:bg-background/20">
              <h3 className="font-default text-lg font-medium uppercase tracking-widest text-white">
                {term.name}
              </h3>
              <ArrowUpRight className="h-4 w-4 text-white/70 transition-colors group-hover:text-white" />
            </div>
          </Link>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function CuratedCollections() {
  return <section data-section-id="225097" id="shop-by-category" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h2 className="font-default text-4xl font-light tracking-tight text-foreground md:text-6xl">
            Shop by Category
          </h2>
          <p className="mt-6 text-lg text-muted-foreground md:text-xl leading-relaxed font-default max-w-md">
            Bridge the gap between clinical care and daily ritual with our curated wellness essentials.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query} className="curated-collections-wrapper">
          <CuratedCollectionsConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}